export default "__VITE_ASSET__Bl8_J$p5__"